import React from "react";

import Popover from "~/shared/ui/Fields/Popover";

import type { StatusPopoverItem } from "./candidateStatusUi";

type StatusUpdatePopoverProps = {
  allowed: boolean;
  items: StatusPopoverItem[];
  direction: "left" | "right";
  selectedValue: string;
  onSelect: (value: string) => void;
  triggerClassName: string;
};

const StatusUpdatePopover = ({
  allowed,
  items,
  direction,
  selectedValue,
  onSelect,
  triggerClassName,
}: StatusUpdatePopoverProps) => {
  if (!allowed) {
    return null;
  }

  return (
    <Popover
      trigger="click"
      content={items}
      direction={direction}
      selectedValue={selectedValue}
      onSelect={(selected) => onSelect(selected.value)}
    >
      <div className={triggerClassName}>Изменить статус</div>
    </Popover>
  );
};

export default StatusUpdatePopover;
